@if(showTable) {
<p-table #dataTable [globalFilterFields]="[
            'bl_name', 
            'address',
            'postal_code',
            'task_point_name',
            'item_count',
            'delivery_point_area_name',
            'source',
            'task_type',
            'task_state',
            'user_name',
            'task_time_window'
        ]" [value]="cloudData" [columns]="visibleColumns"  columnResizeMode="expand"
        [resizableColumns]="true" 
    [(selection)]="taskMovementService.selectedOptionsForTaskMove" [rowHover]="true"
    [scrollable]="true" scrollHeight="flex"
    [loading]="taskInfoService.loading" selectionMode="multiple" [metaKeySelection]="taskInfoService.metaKey"
    [multiSortMeta]="taskInfoService.multiSortMetaUPP"  [virtualScroll]="true" (onColResize)="saveColumnWidth($event)"
    [virtualScrollItemSize]="32"
    (onHeaderCheckboxToggle)="onSelectAllToggle($event)"
    (onRowSelect)="onTaskSelection($event.data)"
    (onRowUnselect)="onTaskUnselection($event.data)"
    [customSort]="isCustomSort"
    (onSort)="onColumnSort($event)"
    dataKey="task_id" selectionMode="multiple" [tableStyle]="{'table-layout': 'fixed','width': '100%'}">
    <ng-template pTemplate="loadingicon">
        <svg id="ag-loading-overlay" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
            <circle class="circle" cx="12" cy="12" r="10" stroke-width="3" stroke="#3A5487"></circle>
            <circle class="dot" cx="21.3" cy="16" r="1.48" fill="#3A5487"></circle>
        </svg>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th style="width: 1.5rem" id="rowHighlight-header" [ngClass]="{'custom-sort-icon':taskInfoService.router.url != navigation.MapLeaflet, 'custom-sort-mapview':taskInfoService.router.url == navigation.MapLeaflet}">
                @if(taskMovementService.taskmoveCount()){
                    <div>
                        <img [src]="sortingService.isCustomSortApplied ? '../../../../../../assets/image/sort_selected.svg' : '../../../../../../assets/image/sort.svg'" (click)="setSelectedTaskSorting()"
                        class="icons-task-bank" onKeyDown="setSelectedTaskSorting()"
                        pTooltip="To sort by selected tasks" [hidden]="isSelectAll"/>
                    </div>
                }
            </th>
            <ng-container >
                <th id="rowHighlight-header" style="width: 2.5rem">S.No.
                </th>
            </ng-container>
            <th id="checkbox-header" style="width: 2.7rem;">
                @if (dataTable.filteredValue??cloudData | selectionRowAllowed) {
                    <p-tableHeaderCheckbox   />
                }
            </th>
            <th id="indicators-header" style="width: 3.5rem;">
                <i class="pi pi-flag"  pTooltip="Shipment Indicators"></i>
            </th>
            <ng-container *ngFor="let column of visibleColumns">
                <th *ngIf="column.field !== 'task_time_window'" pResizableColumn [ngStyle]="{'width': column.width}" [id]="column.field" scope="col"
                    [pSortableColumn]="column.field">
                    {{column.label}}<p-sortIcon [field]="column.field" />
                </th>
                <th *ngIf="column.field === 'task_time_window'" pResizableColumn [ngStyle]="{'width': column.width}" [id]="column.field" scope="col" pSortableColumn="task_time_window">
                    {{column.label}}<p-sortIcon field="task_time_window" />
                </th>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-cloudData let-rowIndex="rowIndex">
        <tr [pSelectableRowDisabled]="!cloudData.isMovementAllowed"
            [pSelectableRow]="cloudData.isMovementAllowed ? cloudData : null" [pSelectableRowIndex]="rowIndex">
            <td id="rowHighlight-header" class="custom-sort-icon"></td>
            <ng-container >
                <td><span>{{cloudData.index}}</span></td>
            </ng-container>
            <td>
                <ng-container *ngIf="cloudData.isMovementAllowed; else showErrorMsg">
                    <p-tableCheckbox [pSelectableRow]="cloudData" [value]="cloudData"></p-tableCheckbox>
                </ng-container>
                <ng-template #showErrorMsg>
                    <i class="pi pi-info-circle info-icon" [pTooltip]="taskInfoService.taskMovementErrorMsg" appendTo="body" autoHide="false" tooltipStyleClass="taskmovement-error-tooltip"></i>
                </ng-template>
            </td>
            <td class="indicator-cell">
                <div class="indicator-rail">
                    @for(indicator of cloudData?.indicators; track indicator.key; let i = $index) {
                        @if(i < 2) {
                            <img [src]="indicator.icon"
                                [pTooltip]="indicator.label"
                                tooltipPosition="bottom"
                                class="indicator-icon"
                                width="16" height="16"
                                [alt]="indicator.label" />
                        }
                    }
                    @if(cloudData?.indicators?.length > 2) {
                        <span class="indicator-overflow"
                            (click)="showIndicatorPanel($event, cloudData); $event.stopPropagation()">
                            +{{cloudData.indicators.length - 2}}
                        </span>
                    }
                </div>
            </td>

            <ng-container *ngFor="let col of visibleColumns">
                <td *ngIf="col.field !== 'task_state' && 
                    col.field !== 'item_count'  && 
                    col.field !== 'task_time_window' && 
                    col.field !== 'address'" class="wrapRowData" [pTooltip]="cloudData[col.field]"
                    tooltipPosition="bottom">
                    {{cloudData[col.field]}}
                </td>
                <td *ngIf="col.field === 'task_state'"><span
                        [ngStyle]="cloudData.task_state | TaskState">{{cloudData.task_state}}</span></td>
                <td *ngIf="col.field === 'address'" class="wrapRowData" [pTooltip]="cloudData.address"
                    tooltipPosition="bottom">
                    <button (click)="$event.stopPropagation(); taskInfoService.showDialog(cloudData ,'address', 'TaskBank')"
                        class="pi pi-pencil edit-icon"></button>
                    {{cloudData.address}}
                </td>
                <td *ngIf="col.field === 'item_count'" [ngClass]="{'pointer-cursor': cloudData.item_count > 0}"
                    (click)="$event.stopPropagation(); openItemDialog(cloudData); $event.stopPropagation();" onKeyDown="openItemDialog(cloudData); $event.stopPropagation();">
                    <a class="anchor" *ngIf="cloudData.item_count > 0">{{cloudData.item_count}}</a>
                    <span *ngIf="cloudData.item_count === 0">{{cloudData.item_count}}</span>
                </td>
                <td *ngIf="col.field === 'task_time_window'" >{{cloudData.task_time_window}}</td>
            </ng-container>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="visibleColumns.length + 4">
                <div class="text-center no-record-label">
                    No Records found.
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>
}
<div class="taskBankSummary">
    @if(taskMovementService.taskmoveCount()){
        <div>
            <p-tag value="{{taskMovementService.taskmoveCount()}} {{taskMovementService.taskmoveCount() == 1 ? 'task' : 'tasks'}} selected" 
            class="primary-chip"/>
        </div>
        @for(kpi of taskMovementService.selectedTaskKPI; track kpi){
            @if(kpi.key==='task_type'){
            <div class="kpi-footer-props" [pTooltip]="kpi.value.toString()" tooltipPosition="top">{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b></div>
            }
            @else {
            <div>{{kpi.key | removeUnderscore | titlecase }} : <b>{{kpi.value}}</b>
            </div>
            }

        }
    }
</div>
@if(DialogType === 'TaskBank' && getShowPopup) {
<p-dialog header="{{taskInfoService.updatePopup.dialogHeader}}"
    [(visible)]="getShowPopup" [modal]="true"
    (onHide)="closeDialog($event)" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [style]="{ width: '70vw'}" [draggable]="false" [resizable]="false">
        <app-update-address
            (onCancel)="closeDialog($event)"
            #updateStateAddressPushToCloud
            [taskId]="taskInfoService.updatePopup.updateTask.task_id"
            (closeDialog)="closeDialog($event); refreshActiveTabData()"></app-update-address>
        <ng-template #footer>
            <ng-container *ngTemplateOutlet="updateStateAddressPushToCloud.updateAddressFooter"></ng-container>
        </ng-template>
    </p-dialog>
}
<p-dialog [header]="itemTitle" [(visible)]="visible" [modal]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '55vw'}" [draggable]="false"
    [resizable]="false">
    <app-route-item-details [showBarcode]="true" [paginator]="true" [taskid]="taskid"
        [itemColumnNames]="itemColumnNames">
    </app-route-item-details>
</p-dialog>

<p-popover #indicatorPanel [dismissable]="true" [style]="{width: '220px'}">
    <div class="indicator-panel-list">
        @for(indicator of activeIndicators; track indicator.key) {
            <div class="indicator-panel-row">
                <img [src]="indicator.icon" width="16" height="16" [alt]="indicator.label" />
                <span>{{indicator.label}}</span>
            </div>
        }
    </div>
</p-popover>